module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ps-451101efffc43d2b1ae6755db0380c6c.svg";